const EMPLOYEE_ID_PARAM_NAMES = ['employeeid', 'employee-id']

/**
 * The style advisor's employee id from the host URL, matched case-insensitively
 * on the same spellings the Active Customers List accepts
 * (`packages/active-customers-list/src/lib/employeeId.ts`) — the hub cannot
 * import it, since that package depends on this one.
 */
export function getEmployeeIdFromUrl(): string {
  if (typeof window === 'undefined') return ''

  for (const [key, value] of new URLSearchParams(window.location.search)) {
    if (EMPLOYEE_ID_PARAM_NAMES.includes(key.toLowerCase()) && value.trim()) {
      return value.trim()
    }
  }

  return ''
}
